import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { contrastTranslationOptions } from './constants'
import { getContrastIndicator, meetsContrastRatioAA } from './helpers'
import * as Styles from './styles'

const ContrastIndicator = ({ color, contrastColor }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const { label, color: indicatorColor, Icon } = getContrastIndicator(meetsContrastRatioAA(color, contrastColor), theme)

  return (
    <Styles.Container>
      <Icon size={16} color={indicatorColor} />
      <Text type="bodySRegular" color={indicatorColor}>
        {t(label, contrastTranslationOptions)}
      </Text>
    </Styles.Container>
  )
}

export default ContrastIndicator
